import React from 'react';
import {injectIntl} from 'react-intl';
import {AutoSaveDropdownBreakField} from 'components/forms/Component Sets/MultiPlatformComponents';

const BreakStepDropdown = (props) => {
  let options = (props.formProxy.currentBaseResource.steps || [])
    .filter(step => (!step.deleted && ( step.type === 'COMPLETE' ||
                                        step.type === 'LEAD_GEN' ||
                                        step.type === 'UGC_PHOTO' ||
                                        step.type === 'RECEIPT_VERIFICATION') ))
    .map(step => {
      const stepType = props.intl.formatMessage({id: `step_types.${step.type.toLowerCase()}`});
      return {
        value: step.id,
        text: step.label ? `${step.label} (${stepType})` : stepType
      };
    });
  return <AutoSaveDropdownBreakField {...props} options={options}/>
};

// class BreakStepDropdown extends React.Component {
//     static propTypes = {
//         intl: intlShape.isRequired
//     };
//
//     getValueFromOnChange = (event, data) => data.value;
//
//     get stepOptions() {
//         return (this.props.formProxy.currentBaseResource.steps || [])
//             .filter(step => !step.deleted)
//             .map(step => {
//                 const stepType = this.props.intl.formatMessage({id: `step_types.${step.type.toLowerCase()}`});
//                 return {
//                     value: step.id,
//                     text: step.label ? `${step.label} (${stepType})` : stepType
//                 };
//             });
//     }
//
//     render() {
//         return (
//             <MultiPlatformField
//               fieldComponent={AutoSaveDropdownBreakField}
//               currentPlatform={this.props.currentPlatform}
//               // fieldConfig={{
//                   // type: AutoSaveDropdown,
//               //     name: this.props.name,
//               //     label: this.props.label,
//               //     labelKey: this.props.labelKey,
//               //     helpContent: this.props.helpContent,
//               //     helpHeader: this.props.helpHeader,
//               //     validationRules: this.props.validationRules,
//               //     required: this.props.required,
//               //     options: this.stepOptions,
//               //     sectionIndex: this.props.sectionIndex
//               // }}
//               // object={this.props.value}
//               {...makeShared(this.props)} />
//         );
//     }
// }

export default injectIntl(BreakStepDropdown);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/BreakStepDropdown.jsx